module.exports = __webpack_public_path__ + "6e6d1f91d28b03434376667cc2bdaaef.png";


//////////////////
// WEBPACK FOOTER
// ./assets/btnControlVideo.png
// module id = +uQg
// module chunks = 27